import styled from 'styled-components';

// Height is applied as an inline style by the component: it changes every open/close
// cycle, and interpolating it here would mint a new styled-components class per pixel
// value. `transition: height` (never `all`) keeps descendant transitions from being
// caught by the container's transitionend settling logic.
export const ContentContainer = styled.div<{ $isSettled: boolean }>`
  overflow: ${({ $isSettled }) => ($isSettled ? 'visible' : 'hidden')};
  transition: height 0.3s ease;
`;

export const Header = styled.div`
  cursor: pointer;
`;
